export enum UserAuthorities {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
  ROLE_AGRONOM = 'ROLE_AGRONOM',
  ROLE_MAIN_AGRONOM = 'ROLE_MAIN_AGRONOM'
}
